import React from 'react'

const Map = props => {
    return (
        <iframe title="map" src={props.map_src} frameBorder="0" style={{ border: 0, width: '100%', height: '100%' }} allowFullScreen></iframe>
    )
}

export default Map


// WEBPACK FOOTER //
// ./src/components/Map.js